import { createSelector } from "reselect";

const selectOrgId = state => state?.session?.user?.profile?.orgId;
const selectIntegrations = state => state?.session?.user?.profile?.integrations || [];
const selectFeedId = (_state, feedId) => feedId;

const selectIntegrationForFeed = createSelector([selectIntegrations, selectFeedId], (integrations, feedId) =>
	integrations.find(int => int.intId === feedId)
);

export const selectCanManageSharedFeed = createSelector(
	[selectOrgId, selectIntegrationForFeed],
	(orgId, integration) => {
		if (!integration) return false;

		const isExternal = Boolean(integration.feedOwnerOrg && integration.feedOwnerOrg !== orgId);

		// Own org feed: sharing policy check not needed
		if (!isExternal) return true;

		// External/shared feed: must have manage allowed by policy
		return (integration.policy?.allowedPermissions || []).includes("manage");
	}
);
